import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import PageHero from "@/components/PageHero";
import ArticleCard from "@/components/ArticleCard";
import EditorialEmptyState from "@/components/EditorialEmptyState";
import { api } from "@/lib/api";
import usePageMeta from "@/hooks/usePageMeta";

export default function InsightsPage() {
  const [articles, setArticles] = useState(null);

  usePageMeta({
    title: "UGI Insights | Editorial Perspectives on International Trade",
    description: "Official UGI market notes, buyer guidance and trade perspectives from Unity Gateway International LLP.",
    type: "website",
  });

  useEffect(() => {
    api.get("/articles").then((response) => setArticles(response.data)).catch(() => setArticles([]));
  }, []);

  return (
    <main data-testid="insights-page">
      <PageHero eyebrow="UGI Insights" title="Editorial perspectives on international trade." description="A dedicated publishing space for official UGI market notes, buyer guidance and trade perspectives." testId="insights-page-hero" />
      <section className="mx-auto max-w-7xl px-5 py-20 sm:px-8 lg:py-28">
        {articles === null && <p data-testid="insights-loading" className="font-serif text-3xl text-[#1C1613]">Loading insights...</p>}
        {articles?.length === 0 && <EditorialEmptyState />}
        {articles?.length > 0 && (
          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {articles.map((article, index) => (
              <motion.div
                key={article.id}
                initial={{ opacity: 0, y: 26 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.7, delay: (index % 3) * 0.09, ease: [0.16, 1, 0.3, 1] }}
              >
                <ArticleCard article={article} testId={`article-card-${article.slug}`} />
              </motion.div>
            ))}
          </div>
        )}
      </section>
    </main>
  );
}
